import { IFilterSettings } from "Domain/Repository/BaseRepository/BaseRepository";

export const SEARCH_TAGS_REQUEST = 'SEARCH_TAGS_REQUEST';

export const searchTagsRequest = ({
     filter = [],
     sorting = { field: 'id', order: 'ASC' },
     pagination = { page: 1, take: 50 },
 }: IFilterSettings) => ({
    type: SEARCH_TAGS_REQUEST,
    payload: { filter, sorting, pagination },
    meta: {
        sorting,
    }
});
